module.exports = __webpack_public_path__ + "static/img/5555.9a5af74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/5555.png
// module id = 0kXC
// module chunks = 1